import { createSelector } from 'reselect'

export const getTicketRefundState = state => state.ticketRefund
export const getValidateTicketRefundState = state => state.ticketRefundValidation
export const getIssuersState = state => state.getIssuers

export const isFetchingTicketRefund = createSelector(getTicketRefundState, refundState =>
  refundState ? refundState.isFetching : null
)
export const getTicketRefundError = createSelector(getTicketRefundState, refundState =>
  refundState ? refundState.error : null
)
export const getTicketRefundSuccess = createSelector(getTicketRefundState, refundState =>
  refundState ? refundState.data : null
)

export const isFetchingValidateTicketRefund = createSelector(
  getValidateTicketRefundState,
  validateTicketRefund => (validateTicketRefund ? validateTicketRefund.isFetching : null)
)
export const getValidateTicketRefundError = createSelector(
  getValidateTicketRefundState,
  validateTicketRefund => (validateTicketRefund ? validateTicketRefund.error : null)
)
export const getValidateTicketRefundSuccess = createSelector(
  getValidateTicketRefundState,
  validateTicketRefund => (validateTicketRefund ? validateTicketRefund.data : null)
)

export const isFetchingIssuers = createSelector([getIssuersState], issuers =>
  issuers ? issuers.isFetching : null
)
export const getIssuersError = createSelector([getIssuersState], issuers =>
  issuers ? issuers.error : null
)
export const getIssuersSuccess = createSelector([getIssuersState], getIssuers => {
  return getIssuers && getIssuers.data ? getIssuers.data : []
})
